module.exports = "/_next/static/images/plates-0e5249ff0f9a3bb823b44e4d940de1b7.png";